import React from 'react';
import "./Welcome.css";
import { Link } from "react-router-dom";

function Welcome() {
    return (
        <div>
            <div className="welcome__header">
                <div className="welcome__headerText">
                    <h1>Welcome to TiTaniht</h1>
                </div>
                <div className="welcome__headerButtons">
                    <Link to="/register" className="link"><button>Sign Up</button></Link>
                    <Link to="/login" className="link"><button>Sign In</button></Link>
                </div>
            </div>
            <div className="welcome__main">
                <div className="welcome__welcomeImage">
                    <img src="Images/Welcome_Page_Image.jpeg" alt="Welcome to TiTaniht" />
                </div>
                <div className="welcome__loginAndRegisterButton">
                    <h2>Stay Informed of what's going around the world.</h2>
                    <Link className="link" to="/register" ><button>Get Started</button></Link>
                </div>
            </div>
        </div>
    )
}

export default Welcome
